import { schema } from 'normalizr';
import { MentorshipProgramCustomCommunication } from '../models/mentorship-program-custom-communications';

export const MentorshipProgramCustomCommunicationSchema = new schema.Entity<MentorshipProgramCustomCommunication>('mentorshipProgramCustomCommunications');

export const MentorshipProgramCustomCommunicationsSchema = new schema.Array(MentorshipProgramCustomCommunicationSchema);
